const ru = {
  common: {
    cancel: 'Отмена',
    save: 'Сохранить',
    saving: 'Сохранение…',
    saved: 'Сохранено',
    saveFailed: 'Не удалось сохранить',
    delete: 'Удалить',
    confirm: 'Подтвердить',
    pleaseWait: 'Подождите…',
    loading: 'Загрузка…',
    add: 'Добавить',
    adding: 'Добавление…',
    create: 'Создать',
    creating: 'Создание…',
    close: 'Закрыть',
    post: 'Отправить',
    retry: 'Повторить',
    unknown: 'Неизвестно',
    online: 'Онлайн',
    offline: 'Не в сети',
    yes: 'Да',
    no: 'Нет',
  },
  auth: {
    badge: '01 / Вход',
    welcomeBack: 'С возвращением.',
    emailLabel: 'Email или имя пользователя',
    passwordLabel: 'Пароль',
    signIn: 'Войти',
    signingIn: 'Подождите…',
    signedInToast: 'С возвращением',
    loginHint: 'Войдите с помощью учётной записи Anahub.',
    failed: 'Не удалось авторизоваться',
    heroLine1: 'Тикеты на входе.',
    heroLine2: 'Merge request на выходе.',
    heroSubtitle:
      'CMR — это минималистичная Kanban-доска со встроенным AI-инженером, который клонирует ваш репозиторий, исправляет тикеты и открывает MR в GitLab.',
    features: {
      dnd: 'Drag & drop',
      multiUser: 'Несколько пользователей',
      claude: 'Claude Sonnet 4.5',
      gitlab: 'MR в GitLab',
    },
    footer: 'v1.0 // Создано с Claude Sonnet 4.5',
  },
  sidebar: {
    projects: 'Проекты',
    newProject: 'Новый проект',
    noProjects: 'Проектов пока нет. Создайте первый.',
    members: 'Участники',
    signOut: 'Выйти',
    language: 'Язык',
    russian: 'Русский',
    english: 'English',
    stats: 'Рейтинг',
  },
  stats: {
    badge: 'Статистика команды',
    title: 'Рейтинг разработчиков',
    subtitle: 'Коммиты, строки кода, комментарии и тикеты по всем проектам.',
    linesAdded: 'Строк добавлено',
    commits: 'Коммиты',
    comments: 'Комментарии',
    tickets: 'Тикеты',
    streak: 'Серия',
    activeDays: 'Активных дней',
    days: 'дн.',
    periodAllTime: 'Всё время',
    periodWeek: 'Эта неделя',
    periodMonth: 'Этот месяц',
    longestStreak: 'Лучшая серия',
    badges: 'Значки',
    badgeLocked: 'Ещё не получен',
    player: 'Разработчик',
    sync: 'Синхр. GitLab',
    syncing: 'Синхронизация…',
    syncDone: 'Синхронизация GitLab завершена',
    syncFailed: 'Ошибка синхронизации',
    loadFailed: 'Не удалось загрузить статистику',
    lastSync: 'Последняя синхр.',
    empty: 'Пока нет активности — создайте тикет, комментарий или коммит в GitLab.',
    emailHint:
      'Коммиты привязываются к аккаунту по email автора. Используйте тот же email в Git, что и при входе в CMR.',
    activityTitle: 'Активность коммитов',
    activityHint: 'Нажмите на разработчика в таблице, чтобы увидеть коммиты и строки по дням.',
    activityEmpty: 'Нет коммитов за этот период.',
    activityLoadFailed: 'Не удалось загрузить график активности',
    closeChart: 'Закрыть',
  },
  newProject: {
    title: 'Новый проект',
    description:
      'Подключите один или несколько репозиториев GitLab, чтобы AI-агент мог их клонировать и открывать Merge Request для тикетов.',
    nameLabel: 'Название',
    descriptionLabel: 'Описание',
    gitlabUrlLabel: 'URL репозитория GitLab',
    gitlabUrlHint:
      'HTTPS ({httpsExample}) или SSH ({sshExample}). Не вставляйте email или адрес страницы.',
    gitlabTokenLabel: 'Персональный токен GitLab',
    gitlabTokenHint:
      'Нужны области {api} и {writeRepo}.',
    gitlabTokenInfo:
      'После создания проекта API клонирует каждый репозиторий в кэш на сервере. Управляйте расположением через {envVar} (по умолчанию: {defaultDir}).',
    defaultBranchLabel: 'Ветка по умолчанию',
    reposTitle: 'Репозитории',
    reposHint:
      'Можно подключить несколько репозиториев (например, backend + frontend) — агент будет работать по всем в каждом тикете.',
    reposOptionalHint:
      'Необязательно — можно создать проект сейчас и добавить репозитории позже в настройках.',
    repoNameLabel: 'Имя',
    repoNamePlaceholder: 'backend, frontend, …',
    addRepoBtn: 'Добавить ещё репозиторий',
    removeRepoAria: 'Удалить этот репозиторий',
    submit: 'Создать проект',
    submitting: 'Создание…',
    createdToast: 'Проект «{name}» создан',
    failedToast: 'Не удалось создать проект',
  },
  personalTokens: {
    title: 'Персональные токены',
    description:
      'Персональный токен действует от вашего имени во всех проектах, где вы участник, — для ваших скриптов и AI-агентов (Claude Code, Cursor). Комментарии через него публикуются от вашего имени.',
    namePlaceholder: 'Ноутбук — Claude Code',
    expiryLabel: 'Срок',
    expiryDays: '{days} дн.',
    expiryNever: 'Бессрочно',
    createBtn: 'Создать токен',
    empty: 'Персональных токенов пока нет.',
    loadFailedToast: 'Не удалось загрузить токены',
    createFailedToast: 'Не удалось создать токен',
    revokedToast: 'Токен отозван',
    revokeFailedToast: 'Не удалось отозвать токен',
    revokeConfirmTitle: 'Отозвать этот токен?',
    revokeConfirmDescription: 'Отозвать «{name}». Всё, что его использует, сразу перестанет работать.',
    revokeConfirmBtn: 'Отозвать токен',
    createdDialogTitle: 'Сохраните персональный токен',
    expiresAt: 'истекает {when}',
    noExpiry: 'бессрочный',
    example:
      'curl {base}/integrations/me -H "Authorization: Bearer cmr_pat_…"\n\n# Claude Code через cmr-mcp:\nclaude mcp add cmr -e CMR_BASE_URL={base} -e CMR_TOKEN=cmr_pat_… -- cmr-mcp',
  },
  settings: {
    button: 'Настройки',
    title: 'Настройки проекта',
    description: 'Метаданные проекта, подключённые репозитории и участники.',
    nameLabel: 'Название',
    descriptionLabel: 'Описание',
    codebaseContextLabel: 'Контекст кодовой базы (для чат-ассистента)',
    codebaseContextHint: 'Вставьте краткую карту кодовой базы — ключевые файлы, папки и их назначение. Чат-ассистент использует это, чтобы указывать файлы, которые нужно изменить в задаче.',
    codebaseContextPlaceholder: 'напр.\nbackend/app/modules/tickets/ — CRUD задач и перемещения по доске\nbackend/app/modules/assistant/ — чат-ассистент PM\nfrontend/src/pages/ProjectBoard.jsx — интерфейс доски',
    digestLabel: 'Ежедневный стендап в чате',
    digestHint: 'Claude публикует ежедневный стендап в чат проекта — застрявшие задачи, долгие ревью и неназначенную работу.',
    gitlabUrlLabel: 'URL репозитория GitLab',
    gitlabUrlHint: 'Только HTTPS или SSH. Не вставляйте email или адрес страницы.',
    gitlabTokenLabel: 'Токен GitLab',
    gitlabTokenPlaceholder: '(оставьте пустым, чтобы сохранить текущий)',
    gitlabTokenHint: 'Нужны области {api} и {writeRepo}.',
    defaultBranchLabel: 'Ветка по умолчанию',
    saveMetaBtn: 'Сохранить название и описание',
    reposTitle: 'Репозитории',
    reposDescription:
      'Репозитории GitLab, с которыми работает AI-агент. Подключите backend + frontend (и больше) — агент будет работать по всем в каждом тикете.',
    reposEmptyOwnerHint:
      'Репозитории ещё не подключены. Вставьте URL GitLab и Personal Access Token ниже, чтобы включить клонирование, создание веток при «в работе» и запуск агента.',
    reposEmptyMemberHint:
      'Репозитории ещё не подключены. Владелец проекта должен подключить хотя бы один репозиторий, чтобы агент мог работать.',
    connectFirstRepoBtn: 'Подключить репозиторий',
    gitlabUrlFormatHint:
      'HTTPS — https://gitlab.com/group/project, либо SSH — git@gitlab.com:group/project.git. Не email и не адрес страницы.',
    gitlabUrlError: {
      empty: 'URL GitLab обязателен.',
      format:
        'Это не Git-URL. Используйте HTTPS (https://gitlab.com/group/project) или SSH (git@gitlab.com:group/project.git). Вы вставили email или адрес страницы.',
      incomplete: 'В URL не хватает пути group/project (например, https://gitlab.com/group/project).',
    },
    recloneBlockedByUrl: 'Исправьте URL GitLab и сохраните перед повторным клонированием.',
    repoMissingUrlWarning:
      'У этого репозитория не задан URL GitLab. Введите его в поле ниже и нажмите «Сохранить репозиторий». Агент клонирует репозиторий при первом запуске на нём.',
    repoNameLabel: 'Имя',
    repoNamePlaceholder: 'backend, frontend, …',
    branchPrefixLabel: 'Префикс ветки',
    branchPrefixPlaceholder: 'feat',
    branchPrefixHint:
      'Используется в названии ветки: {prefix}-{ticket}. Если оставить пустым — берётся имя проекта. Кириллица транслитерируется (Добавить → dobavit).',
    repoSaveBtn: 'Сохранить репозиторий',
    repoSavingBtn: 'Сохранение…',
    repoSavedToast: 'Репозиторий обновлён',
    repoSaveFailedToast: 'Не удалось обновить репозиторий',
    repoRemoveBtn: 'Удалить',
    repoRemoveConfirmTitle: 'Удалить этот репозиторий?',
    repoRemoveConfirmDescription:
      'Удалить «{name}» из проекта. Агент больше не будет с ним работать. Это действие нельзя отменить.',
    repoRemoveConfirmBtn: 'Удалить репозиторий',
    repoRemovedToast: 'Репозиторий удалён',
    repoRemoveFailedToast: 'Не удалось удалить репозиторий',
    repoAddedToast: 'Репозиторий добавлен — будет клонирован при первом запуске агента.',
    repoAddFailedToast: 'Не удалось добавить репозиторий',
    repoMinHint: 'В проекте должен быть хотя бы один репозиторий.',
    addRepoBtn: 'Добавить ещё репозиторий',
    addingRepoBtn: 'Добавление…',
    addRepoSubmitBtn: 'Подключить репозиторий',
    recloneBtn: 'Переклонировать',
    recloneStarting: 'Запуск…',
    recloneStartedToast: 'Переклонирование запущено',
    recloneFailedToast: 'Не удалось переклонировать',
    lastClonedAtShort: 'Клонирован {when}',
    repoStatus: {
      idle: 'Не клонирован',
      cloning: 'Клонирование…',
      ready: 'Готов',
      failed: 'Ошибка',
    },
    apiKeys: {
      title: 'API-интеграция',
      description:
        'Создайте API-ключ проекта, чтобы другие приложения могли создавать, обновлять и перемещать тикеты через integration API.',
      nameLabel: 'Название ключа',
      namePlaceholder: 'Основное приложение, CI-бот, …',
      createBtn: 'Создать ключ',
      creatingBtn: 'Создание…',
      empty: 'API-ключей пока нет.',
      ownerOnlyHint: 'Управлять API-ключами может только владелец проекта.',
      createdToast: 'API-ключ создан',
      createFailedToast: 'Не удалось создать API-ключ',
      loadFailedToast: 'Не удалось загрузить API-ключи',
      revokedToast: 'API-ключ отозван',
      revokeFailedToast: 'Не удалось отозвать API-ключ',
      revokeConfirmTitle: 'Отозвать этот API-ключ?',
      revokeConfirmDescription:
        'Отозвать «{name}». Интеграции с этим ключом сразу перестанут работать.',
      revokeConfirmBtn: 'Отозвать ключ',
      createdDialogTitle: 'Сохраните API-ключ',
      createdDialogDescription:
        'Секрет показывается только один раз. Скопируйте его сейчас — после закрытия окна его не увидеть.',
      secretLabel: 'API-ключ',
      copiedToast: 'Скопировано в буфер обмена',
      copyFailedToast: 'Не удалось скопировать',
      createdAt: 'Создан {when}',
      lastUsedAt: 'Использован {when}',
      example:
        'GET …/tickets/by-assignee?email=user@company.com\nGET …/tickets/by-creator?email=user@company.com\nGET …/tickets?user_email=user@company.com\nX-CMR-API-Key: cmr_live_…',
    },
    membersTitle: 'Участники',
    save: 'Сохранить',
    saving: 'Сохранение…',
    saveSuccessToast: 'Проект обновлён',
    saveFailedToast: 'Не удалось сохранить проект',
    deleteBtn: 'Удалить проект',
    deleteConfirmTitle: 'Удалить этот проект?',
    deleteConfirmDescription:
      'Удалить «{name}» и все его тикеты и комментарии. Это действие нельзя отменить.',
    deleteConfirmBtn: 'Удалить проект',
    deletedToast: 'Проект удалён',
    deleteFailedToast: 'Не удалось удалить проект',
  },
  members: {
    title: 'Участники',
    dialogDescription:
      'Владелец может добавлять и удалять участников. Участники видят проект, создают тикеты и запускают агента.',
    none: 'Участников пока нет.',
    ownerBadge: 'Владелец',
    pendingBadge: 'Ожидает',
    addPlaceholder: 'collega@example.com',
    addBtn: 'Добавить',
    addingBtn: 'Добавление…',
    helpText:
      'Участники видят этот проект, создают тикеты и запускают агента. Если пользователь ещё не входил, приглашение остаётся в ожидании и активируется при первом входе.',
    addedToast: 'Добавлен {email}',
    invitedToast: 'Приглашение отправлено: {email} — присоединится при входе',
    addFailedToast: 'Не удалось добавить участника',
    confirmRemove: 'Удалить {label} из проекта?',
    removedToast: 'Участник удалён',
    removeFailedToast: 'Не удалось удалить участника',
    removeTitle: 'Удалить участника',
    confirmCancel: 'Отменить приглашение для {email}?',
    cancelledToast: 'Приглашение отменено',
    cancelFailedToast: 'Не удалось отменить приглашение',
    cancelTitle: 'Отменить приглашение',
    loadFailedToast: 'Не удалось загрузить участников',
  },
  projectBoard: {
    projectLabel: 'Проект',
    noReposTitle: 'Репозитории не подключены',
    noReposBody:
      'Откройте Настройки → Репозитории, чтобы добавить URL GitLab и Personal Access Token. Без этого вы не сможете создавать ветки из тикета и агент не сможет запуститься.',
    cloningTitle: 'Клонирование репозиториев',
    cloningBodyMulti: 'Агент скачивает: {names}. Прогресс отображается в логе агента у тикета.',
    cloneFailedTitle: 'Клонирование не удалось',
    cloneFailedBody:
      '. Проверьте URL, области токена ({api}, {writeRepo}) и название ветки, затем используйте ',
    cloneFailedAction: 'Настройки → Переклонировать',
    loadFailedToast: 'Не удалось загрузить проект',
    moveFailedToast: 'Не удалось переместить тикет',
    ticketCreatedToast: 'Тикет создан',
    ticketCreateFailedToast: 'Не удалось создать тикет',
    ticketDeletedToast: 'Тикет удалён',
    ticketDeleteFailedToast: 'Не удалось удалить тикет',
    assigneeUpdateFailedToast: 'Не удалось обновить исполнителя',
    searchPlaceholder: 'Поиск тикетов…',
    filterByAssignee: 'Фильтр по исполнителю',
    filterByCreator: 'Фильтр по автору',
    filterModeAssignee: 'Исполнитель',
    filterModeCreator: 'Создал',
    allAssignees: 'Все исполнители',
    allCreators: 'Все авторы',
    userFilterSearchPlaceholder: 'Поиск пользователей…',
    noUsersMatch: 'Пользователи не найдены',
    unassigned: 'Без исполнителя',
    clearFilters: 'Сбросить фильтры',
    moreLabels: 'Ещё метки',
    deleteLabelTitle: 'Удалить метку',
    deleteLabelConfirmTitle: 'Удалить метку «{name}»?',
    deleteLabelConfirmDescription: 'Метка будет снята со всех тикетов проекта, включая корзину. Тикетов с этой меткой на доске: {count}.',
    deleteLabelConfirmBtn: 'Удалить',
    labelDeletedToast: 'Метка «{name}» удалена',
    labelDeleteFailedToast: 'Не удалось удалить метку',
    noTagsYet: 'Тегов пока нет',
    trashBtn: 'Корзина',
    trashTitle: 'Корзина',
    trashSubtitle: 'Удалённые тикеты хранятся здесь. Восстановите их, чтобы вернуть на доску, или очистите корзину, чтобы удалить навсегда.',
    trashEmpty: 'Корзина пуста.',
    trashLoadFailed: 'Не удалось загрузить корзину',
    trashRestoreBtn: 'Восстановить',
    trashPurgeBtn: 'Удалить навсегда',
    trashEmptyBtn: 'Очистить корзину',
    trashRestoredToast: 'Тикет восстановлен',
    trashRestoreFailedToast: 'Не удалось восстановить тикет',
    trashPurgedToast: 'Тикет удалён навсегда',
    trashPurgeFailedToast: 'Не удалось удалить тикет навсегда',
    trashPurgeConfirmTitle: 'Удалить тикет навсегда?',
    trashPurgeConfirmDescription:
      'Тикет T#{number} будет удалён из проекта окончательно вместе с комментариями и логами агента. Это действие необратимо.',
    trashEmptyConfirmTitle: 'Очистить корзину?',
    trashEmptyConfirmDescription:
      'Все тикеты в корзине будут удалены навсегда вместе с комментариями и логами агента. Это действие необратимо.',
    trashDeletedAt: 'Удалён {date}',
  },
  chat: {
    btn: 'Чат',
    title: 'Чат проекта',
    emptyTitle: 'Пока нет сообщений',
    emptyHint: 'Попросите PM создать или обновить задачи либо спросите о доске.',
    placeholder: 'Сообщение для PM…',
    send: 'Отправить',
    typing: 'PM отвечает…',
    noAi: 'У вас нет доступа к AI в этом проекте — PM не ответит на ваши сообщения. Спросите владельца.',
    placeholderNoAi: 'Сообщение для команды…',
  },
  kanban: {
    backlog: 'Тикеты',
    inProgress: 'В работе',
    agent: 'Агент',
    review: 'Код Ревью',
    blocked: 'Есть вопрос в комментах',
    testing: 'Тест в браузере',
    done: 'Готово',
    agentHint: 'Перетащите сюда тикет, чтобы отправить AI-агенту — он откроет MR.',
    empty: '— пусто —',
  },
  newTicket: {
    title: 'Новый тикет',
    description:
      'Опишите, что нужно сделать. Чёткие, конкретные описания помогают агенту лучше работать.',
    titleLabel: 'Заголовок',
    descriptionLabel: 'Описание',
    descriptionPlaceholder: 'Введите @, чтобы вставить путь к файлу репозитория.',
    priorityLabel: 'Приоритет',
    assigneeLabel: 'Исполнитель',
    unassigned: 'Не назначен',
    labelsLabel: 'Метки (через запятую)',
    labelsPlaceholder: 'bug, frontend, urgent',
    targetReposLabel: 'Целевые репозитории',
    targetReposHint:
      'Выделенные репозитории будут переданы агенту. Если ничего не выбрано — используются все.',
    submit: 'Создать тикет',
    submitting: 'Создание…',
    attachBtn: 'Прикрепить файл',
    attachAria: 'Прикрепить файл к описанию',
    attachUnsupported: 'Неподдерживаемый тип файла',
    attachTooLarge: 'Файл слишком большой',
    attachRemoveAria: 'Удалить вложение',
    attachmentsLabel: 'Вложения',
  },
  priority: {
    low: 'Низкий',
    medium: 'Средний',
    high: 'Высокий',
    urgent: 'Срочный',
  },
  ticketCard: {
    ticketNumberTitle: 'Тикет #{number}',
    deleteTitle: 'Удалить тикет',
    deleteConfirmTitle: 'Удалить тикет?',
    deleteConfirmDescription:
      'Удалить «{title}» с этой доски. Действие нельзя отменить.',
    deleteConfirmBtn: 'Удалить тикет',
    agentWorking: 'Агент работает',
    mrOpened: 'MR открыт',
    agentFailed: 'Агент завершился с ошибкой',
    agentPartial: 'Частично',
    queued: 'в очереди агента',
    idle: 'ожидание',
    assignTo: 'Назначить',
    assignedTo: 'Назначено: {name}',
    assignSomeone: 'Назначить кого-то',
    agentStatusTitle: {
      idle: 'Агент ожидает',
      planning: 'Агент планирует',
      awaiting_approval: 'Ожидает одобрения плана',
      running: 'Агент работает',
      success: 'MR открыт',
      partial: 'Частичный результат',
      failed: 'Агент завершился с ошибкой',
    },
  },
  ticketDetail: {
    label: 'Тикет',
    closeAria: 'Закрыть панель',
    deleteAria: 'Удалить тикет',
    deleteConfirmTitle: 'Удалить этот тикет?',
    deleteConfirmDescription:
      'Удалить тикет T#{number} из этого проекта. Комментарии и логи агента будут удалены. Это действие нельзя отменить.',
    deleteConfirmBtn: 'Удалить тикет',
    statusLabel: 'Статус',
    priorityLabel: 'Приоритет',
    assigneeLabel: 'Исполнитель',
    statusBacklog: 'Тикеты',
    statusInProgress: 'В работе',
    statusAgent: 'Агент (автозапуск)',
    statusBlocked: 'Есть вопрос в комментах',
    statusTesting: 'Тест в браузере',
    statusReview: 'Код Ревью',
    statusDone: 'Готово',
    descriptionLabel: 'Описание',
    descriptionPlaceholder: 'Что нужно сделать? Введите @, чтобы вставить путь к файлу. Картинки можно вставить из буфера обмена.',
    descriptionEditHint: 'Нажмите, чтобы редактировать',
    labelsLabel: 'Теги',
    addLabelPlaceholder: 'Добавить тег…',
    addLabelPlaceholderEmpty: 'Добавьте теги (Enter или запятая)',
    removeLabelAria: 'Удалить тег {label}',
    uploadFailedToast: 'Не удалось загрузить изображение',
    aiTitle: 'AI-агент',
    aiSubtitle: 'Claude Sonnet 4.5',
    viewMr: 'Открыть MR',
    branchLabel: 'Ветка',
    copyCheckout: 'Скопировать git checkout',
    inProgressBranchesTitle: 'Ветки для разработки',
    checkoutCopied: 'Команда скопирована: {cmd}',
    copyFailed: 'Не удалось скопировать',
    copyContent: 'Копировать',
    copyContentHint: 'Скопировать задачу целиком как текст — скриншоты добавятся ссылками для скачивания',
    contentCopied: 'Задача скопирована',
    contentCopiedWithImages: 'Задача скопирована — скриншотов: {count} (ссылками для скачивания)',
    createBranch: 'Создать ветку',
    branchCreating: 'Создание…',
    noBranchYet: 'Ветки ещё нет',
    branchCreatedToast: 'Ветка создана',
    branchCreateFailed: 'Не удалось создать ветку',
    reviewTitle: 'AI-ревью',
    reviewRun: 'Проверить изменения',
    reviewRerun: 'Повторить ревью',
    reviewRunning: 'Проверяю…',
    reviewRunningBody: 'Анализирую изменения ветки… это может занять немного времени.',
    reviewHint: 'Запустите AI-ревью ветки задачи — что изменилось и возможные риски.',
    reviewNoBranch: 'Сначала создайте ветку и запушьте изменения, затем запустите ревью.',
    reviewFailedToast: 'Не удалось выполнить ревью',
    reviewWhatChanged: 'Что изменилось',
    reviewRisks: 'Возможные риски',
    reviewPerRepo: 'Ревью по репозиториям',
    reviewGeneratedAt: 'Проверено {date}',
    statusPrefix: 'Статус: ',
    idle: 'Ожидание',
    working: 'Работает…',
    success: 'Все MR открыты',
    partial: 'Частично',
    failed: 'Ошибка',
    planning: 'Планирование…',
    awaitingApproval: 'Ожидает одобрения',
    runBtn: 'Запустить агента',
    retryBtn: 'Повторить',
    runningBtn: 'Выполняется…',
    retryRepoBtn: 'Повторить',
    runStartedToast: 'Агент запущен — сначала будет план для проверки.',
    runFailedToast: 'Не удалось запустить агента',
    stopBtn: 'Остановить',
    stopRequestedToast: 'Остановка агента…',
    stopFailedToast: 'Не удалось остановить агента',
    approvePlanBtn: 'Одобрить и кодить',
    rejectPlanBtn: 'Отклонить',
    planApprovedToast: 'План одобрен — кодирование запущено.',
    planApproveFailedToast: 'Не удалось одобрить план',
    planRejectedToast: 'План отклонён.',
    planRejectFailedToast: 'Не удалось отклонить план',
    planReviewTitle: 'Проверьте план перед кодом',
    planReviewBody:
      'Агент остановился после планирования. Проверьте план по каждому репозиторию и одобрите, чтобы начать кодирование, либо отклоните и отредактируйте тикет.',
    planFilesLabel: 'Файлы, которые планируется изменить',
    planApproachLabel: 'Подход',
    planRisksLabel: 'Риски / открытые вопросы',
    logEmpty: '[ активности агента пока нет — нажмите «Запустить агента» ]',
    repoStatus: {
      idle: 'Ожидание',
      running: 'Выполняется…',
      success: 'MR открыт',
      failed: 'Ошибка',
    },
    commentsTitle: 'Комментарии ({count})',
    commentPlaceholder: 'Напишите комментарий…',
    commentAttachImage: 'Прикрепить фото (или вставьте из буфера)',
    commentSubmit: 'Отправить',
    commentEditAria: 'Редактировать комментарий',
    commentDeleteAria: 'Удалить комментарий',
    commentEditedTag: 'изменён',
    commentDeleteConfirmTitle: 'Удалить комментарий?',
    commentDeleteConfirmDescription: 'Комментарий будет удалён без возможности восстановления.',
    commentDeleteConfirmBtn: 'Удалить',
    commentDeleteFailed: 'Не удалось удалить комментарий',
    unknownAuthor: 'Неизвестно',
    viaSource: 'из {source}',
    createdBy: 'Создал {name}',
  },
  agent: {
    start: 'AI',
    startHint: 'Передать тикет агенту Claude',
    resume: 'Продолжить',
    stop: 'Стоп',
    preview: 'Превью',
    openPreview: 'Открыть превью',
    previewStarting: 'Превью запускается…',
    previewSleeping: 'Превью спит — откроется за ~1 мин',
    previewFailed: 'Превью не запустилось',
    title: 'Агент',
    disabledHint: 'Агент выключен для проекта — включите в Настройки → Агент.',
    noAccess: 'Нет доступа к AI — спросите владельца проекта',
    offline: 'нет связи',
    log: 'Ход работы',
    mr: 'MR',
    lastError: 'Ошибка',
    startedToast: 'Агент поставлен в очередь',
    stoppedToast: 'Агент остановлен',
    previewToast: 'Превью запускается',
    actionFailed: 'Не удалось выполнить действие',
    author: 'Claude',
    state: {
      queued: 'В очереди',
      understanding: 'Разбирается',
      waiting_answer: 'Ждёт ответа',
      waiting_go: 'Ждёт подтверждения',
      coding: 'Пишет код',
      testing: 'Тестирует',
      in_review: 'На ревью',
      stopped: 'Остановлен',
      failed: 'Ошибка',
      done: 'Готово',
    },
    settings: {
      title: 'Агент',
      hint: 'Claude Code работает над тикетами по кнопке «AI». Настройки видит только владелец; секреты хранятся зашифрованными и не показываются.',
      enabled: 'Агент включён',
      model: 'Модель',
      modelPlaceholder: 'по умолчанию (например, opus)',
      instructions: 'Инструкции для агента',
      instructionsPlaceholder: 'Что агент должен знать о проекте в каждой сессии',
      limits: 'Лимиты',
      maxTurns: 'Макс. шагов за запуск',
      timeout: 'Таймаут запуска, мин',
      testLoops: 'Попыток теста',
      stack: 'Тестовый стенд и превью',
      stackHint: 'Shell-скрипты, запускаются в рабочей папке тикета. Доступны $CMR_STACK_NAME, $CMR_WORKSPACE, $CMR_PORT_WEB, $CMR_PORT_API, $CMR_PORT_DB. Фронтенд должен слушать $CMR_PORT_WEB.',
      stackUp: 'Запуск (stack_up)',
      stackDown: 'Остановка (stack_down)',
      login: 'Тестовый вход (Keycloak)',
      keycloakUrl: 'Keycloak URL',
      realm: 'Realm',
      clientId: 'Client ID',
      username: 'Логин',
      password: 'Пароль',
      prod: 'Доступ к проду',
      prodDsn: 'Prod DB DSN',
      kubeContext: 'kube context',
      loki: 'Loki URL',
      git: 'Git (бот)',
      gitUsername: 'Пользователь',
      gitToken: 'Токен (push + MR)',
      gitTokenHint: 'Пусто — используется токен репозитория.',
      aiUsers: 'Кто может пользоваться AI',
      aiUsersHint: 'Запускать агента, будить его комментариями и общаться с PM в чате. Вы (владелец) можете всегда.',
      aiUsersEmpty: 'В проекте пока нет других участников.',
      extraEnv: 'Доп. переменные окружения (KEY=VALUE построчно)',
      inbox: 'Обращения из других приложений',
      autoStart: 'Запускать агента сразу на тикетах из других приложений (обращения из DM)',
      webhookUrl: 'Webhook URL',
      webhookUrlHint: 'Изменения тикетов с external_id отправляются сюда (POST JSON)',
      webhookSecret: 'Секрет webhook',
      webhookSecretHint: 'Подпись: X-CMR-Signature = sha256 HMAC тела',
      secretSet: 'задан — введите новое значение, чтобы заменить',
      secretEmpty: 'не задан',
      clear: 'Удалить',
      save: 'Сохранить настройки агента',
      saved: 'Настройки агента сохранены',
      loadFailed: 'Не удалось загрузить настройки агента',
    },
  },
  repoMentions: {
    listAria: 'Файлы репозитория',
    cloneFirst: 'Репозиторий ещё не клонирован — @-выбор файлов заработает после первого запуска агента на этом репозитории.',
    loading: 'Загрузка файлов…',
    notReady: 'Репозиторий ещё не готов.',
    loadError: 'Не удалось загрузить файлы.',
    noMatch: 'Совпадений не найдено.',
    pickRepo: 'Выберите репозиторий',
  },
};

export default ru;
